import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store/index'
import Utils from '@/utils/index'
import Home from '@/views/Home.vue'
import Distance from '@/views/Distance.vue'
Vue.use(VueRouter)

const requireLoginAuth = (to, from, next) => {
  var operID = Utils.getWithExpiry('operID')
  if (!operID) {
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
}

const routes = [
  {
    path: '/',
    component: Home,
    children: [
      { path: '/', component: Distance },
      { path: 'distance', component: Distance, meta: { keepAlive: true } }
    ]
  },
  { // beforeEnter: requireLoginAuth,
    path: '/home',
    component: Home,
    children: [
      { path: '/', component: Distance },
      { path: 'distance', component: Distance, meta: { keepAlive: true } }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
